<seira-public-modal [close]="bsModalRef.hide">
	<label
		class="text-tertiary font-size-24 d-flex m-0"
		style="font-weight: 500"
		title>
		Filtro do monitoramento de rede de estações
	</label>

	<form
		[formGroup]="formEstacao"
		class="d-flex flex-column justify-content-center"
		content>
		<div class="row">
			<div class="col-lg-6 col-12 mt-2">
				<seira-public-select
					optionLabel="label"
					optionValue="value"
					placeholder="Selecione..."
					label="Tipo de estação"
					[options]="tiposEstacao"
					notFoundText="Nenhum tipo de estação encontrado"
					formControlName="tipoEstacao"
					#seiraSelectTipoEstacao />
			</div>
			<div class="col-lg-6 col-12 mt-2">
				<seira-public-select
					[carregando]="isCarregandoOpcoesSelect"
					[isDesabilitado]="isCarregandoOpcoesSelect"
					placeholder="Selecione..."
					label="Bacia"
					[options]="bacias"
					optionLabel="nome"
					optionValue="id"
					notFoundText="Nenhuma bacia encontrada"
					formControlName="bacia"
					#seiraSelectBacias />
			</div>
			<div class="col-lg-6 col-12 mt-2">
				<seira-public-select
					[carregando]="isCarregandoOpcoesSelect"
					[isDesabilitado]="isCarregandoOpcoesSelect"
					placeholder="Selecione..."
					label="Município"
					[options]="municipios"
					optionLabel="nome"
					optionValue="id"
					notFoundText="Nenhum município encontrado"
					formControlName="municipio"
					#seiraSelectMunicipio />
			</div>
			<div class="col-lg-6 col-12 mt-2">
				<seira-public-select
					[carregando]="isCarregandoOpcoesSelect"
					[isDesabilitado]="isCarregandoOpcoesSelect"
					placeholder="Selecione..."
					label="Microrregião"
					[options]="microrregioes"
					optionLabel="nome"
					optionValue="id"
					notFoundText="Nenhuma microrregião encontrada"
					formControlName="microrregiao"
					#seiraSelectMicrorregioes />
			</div>
			<div class="col-lg-6 col-12 mt-2">
				<seira-public-select
					[carregando]="isCarregandoOpcoesSelect"
					[isDesabilitado]="isCarregandoOpcoesSelect"
					placeholder="Selecione..."
					label="Mesorregião"
					[options]="mesorregioes"
					optionLabel="nome"
					optionValue="id"
					notFoundText="Nenhuma mesorregião encontrada"
					formControlName="mesorregiao"
					#seiraSelectMesorregioes />
			</div>
			<div class="col-lg-6 col-12 mt-2">
				<seira-public-select
					[carregando]="isCarregandoOpcoesSelect"
					[isDesabilitado]="isCarregandoOpcoesSelect"
					placeholder="Selecione..."
					label="Região Pluviométrica"
					[options]="regioes"
					optionLabel="nome"
					optionValue="id"
					notFoundText="Nenhuma região encontrada"
					formControlName="regiao"
					#seiraSelectRegioes />
			</div>
		</div>
	</form>
	<div footer class="d-flex justify-content-center mt-3 align-items-center">
		<seira-public-button (clicked)="salvarFiltros()"
			>Filtrar</seira-public-button
		>
		<seira-public-a *ngIf="existeValoresCampos()" (click)="limparFiltros()"
			>Limpar</seira-public-a
		>
	</div>
</seira-public-modal>
